import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Thumbs, EffectFade, Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

// import styles bundle
import 'swiper/swiper.css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './index.pcss';

document.addEventListener('alpine:init', () => {
    Alpine.data('initOpinionsMosaicSlider', () => {
        return {
            swiperThumb: null as Swiper | null,
            swiper: null as Swiper | null,
            slideIndex: 0,
            sliderPause: false,
            init() {
                const swiperParams: SwiperOptions = {
                    modules: [Navigation, Keyboard, Pagination, Thumbs, EffectFade, Autoplay],
                    init: false,
                    loop: true,
                    effect: "fade",
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    centeredSlides: true,
                    spaceBetween: 16,
                    watchSlidesProgress: true,
                    slidesPerView: 1,
                    preventClicks: false,
                    keyboard: {
                        enabled: true,
                    },
                    pagination: {
                        clickable: true,
                        el: this.$refs.pagination,
                        type: 'bullets',
                    },
                    navigation: {
                        prevEl: this.$refs.buttonPrev,
                        nextEl: this.$refs.buttonNext,
                    },
                };
                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams,
                );
                this.swiper = swiper;

                this.$nextTick(() => {
                    swiper.init();
                });
            },
            pauseSlider() {
                if (this.sliderPause == false) {
                    this.sliderPause = true;
                    this.swiper?.autoplay.stop();
                } else {
                    this.sliderPause = false;
                    this.swiper?.autoplay.start();
                }
            }
        };
    });
});
